import {ScormType} from "./common/ScormType";
import {ScormDelegateApi} from "./scorm_1_2/ScormDelegateApi";
import {Scorm2004DelegateApi} from "./scorm_1_3/Scorm2004DelegateApi";

window.API = null;
window.API_1484_11 = null;

export function getGlobalApi() {
    return window.API;
}

export function isTtsApi( api ) {
    return api && typeof (api.TTIsDelegateApi) === "function" && api.TTIsDelegateApi();
}

export function setTtsApiAsGlobalApi(api) {

    if (api.TTGetApiType() === ScormType.SCORM_1_3) {
        window.API_1484_11 = api;
    }

    window.API = api;
}

export function createDelegateApi(lmsApi, scormType, masteryScore) {

    if (scormType === ScormType.SCORM_1_2) {
        return createScorm_1_2_DelegateApi(lmsApi, masteryScore);
    }

    if (scormType === ScormType.SCORM_1_3) {
        return createScorm_1_3_DelegateApi(lmsApi, masteryScore);
    }

    return null;
}

function createScorm_1_2_DelegateApi( lmsApi, masteryScore ) {
    const scormDelegateApi = new ScormDelegateApi(lmsApi, masteryScore);
    window.API = scormDelegateApi;
    return scormDelegateApi.TTInitializeApi() === "true" ? scormDelegateApi : null;
}

function createScorm_1_3_DelegateApi( lmsApi, masteryScore ) {
    const scorm2004DelegateApi = new Scorm2004DelegateApi(lmsApi, masteryScore);
    window.API_1484_11 = scorm2004DelegateApi;
    window.API = scorm2004DelegateApi;
    return scorm2004DelegateApi.TTInitializeApi() === "true" ? scorm2004DelegateApi : null;
}

export function isSequenceConnected() {
    return window.API && (window.API.TTSCOIsInUse() === "true");
}
